/**
 * ifやswitchの末尾で、網羅チェックされていることを検証するために'存在し得ない値'を受け取る関数です。
 * 網羅が完全な場合、この関数を呼び出すコードはエラーになりませんが、不完全な場合はコンパイルエラーになります。
 */
export const assertExhaustive = (x: never): never => {
  // このエラーが実際にthrowされることはない想定
  throw new Error(x)
}
